export enum InvestigationSessionStatus {
	WaitingStart = 1,
	InProgress = 2,
	Ended = 3,
	NotHeld = 4,
	Cancelled = 5,
	WaitingAnswers = 6,
	AnswersReceived = 7,
	NoAnswerAwaitingDecision = 8,
	AdditionalPeriodAwaitingDecision = 9,
	ExcuseAwaitingDecision = 10,
}
